import {ReducerStatuses} from "services/utils/utils";
import {createSlice} from "@reduxjs/toolkit";
import errorHandler from "errorReporting";

export const initialState = {
    get: {
        status: ReducerStatuses.IDLE,
        error: ""
    },
    save: {
        status: ReducerStatuses.IDLE,
        error: ""
    },
    data: {
        image: null,
        firstName: "",
        lastName: "",
        birthDate: "",
        gender: "",
        office: "",
        userBio: "",
        phone: "",
        languages: [],
        linkedin: "",
        twitter: "",
        website: "",
        skills: [],
        interests: [],
        links: [],
        special_request_remaining: 0
    },
    qr: null
};

const slice = createSlice({
    name:"profile",
    initialState,
    reducers:{
        getProfileStart: (state) => {
            state.get.status = ReducerStatuses.LOADING;
        },
        getProfileSuccess: (state, {payload}) => {
            state.get.status = ReducerStatuses.IDLE;
            state.data = {
                ...state.data,
                ...payload
            }
            errorHandler.setUser(state.data.id);
        },
        getProfileError: (state, {payload}) => {
            state.get.status = ReducerStatuses.ERROR;
            state.get.error = payload;
        },
        saveProfileStart: (state) => {
            state.save.status = ReducerStatuses.LOADING;
        },
        saveProfileSuccess: (state) => {
            state.save.status = ReducerStatuses.IDLE;
        },
        saveProfileError: (state, {payload}) => {
            state.save.status = ReducerStatuses.ERROR;
            state.save.error = payload;
        },
        generateQrCodeStart: () => {},
        generateQrCodeSuccess: (state, {payload}) => {
            state.qr = payload;
        }
    },
    extraReducers: {
        "auth/resetAuth": (state) => {
            state.data = initialState.data;
        }
    }
});

const {reducer, actions} = slice;
export const {
    getProfileStart, getProfileSuccess, getProfileError,
    saveProfileStart, saveProfileSuccess, saveProfileError,
    generateQrCodeStart, generateQrCodeSuccess
} = actions;
export default reducer;

